export default "__VITE_ASSET__BWbM3UYk__"